
import { Component, Prop, Vue } from 'bits/vue'
import { SnackbarNotificationType } from 'enums'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from 'library/v4/components/OzPlainButton.vue'

@Component({
  components: { OzIcon, OzPlainButton },
})
export default class extends Vue {
  OzPlainButtonColorScheme = OzPlainButtonColorScheme
  OzPlainButtonSizePreset = OzPlainButtonSizePreset
  SnackbarNotificationType = SnackbarNotificationType

  /**
   * Type of snakcbar notification
   */
  @Prop({ required: true, default: SnackbarNotificationType.success }) notificationType!: SnackbarNotificationType

  /**
   * Displayed message of the snackbar
   */
  @Prop({ required: true }) message!: string

  /**
   * Icon to display on the snackbar
   */
  @Prop({ required: false }) iconName!: string

  /**
   * Unique id associated with the snackbar
   */
  @Prop({ required: true }) uid!: string

  /**
   * Text for clickable action
   */
  @Prop({ required: false }) actionText!: string

  /**
   * Whether dark mode is active or not
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  actionTextClick(event) {
    /**
     * Click event
     * @property {MouseEvent} event click event
     */
    this.$emit('action-text-click', event)
  }
}
